export default __webpack_public_path__ + "d37bb7a8ff0410e6b5bf6e48d0d0337e.png";